export default {"host":"https://mileage.autos","trailingSlash":false,"inLanguage":"en"}